import { useEffect, useState } from 'react';

export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 700);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      aria-label="返回顶部"
      className="fixed bottom-6 right-5 z-50 flex h-11 w-11 cursor-pointer items-center justify-center rounded-full bg-primary-500 text-background-50 transition-colors hover:bg-primary-600 md:bottom-8 md:right-8"
    >
      <i className="ri-arrow-up-line text-lg"></i>
    </button>
  );
}